var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"max-height":"500px"}},[_c('canvas',{attrs:{"id":_vm.id,"height":"300px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }